import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_34: FaireProductEntity = {
  token: "legacy_prod_abbott-34",
  type: "product",
  name: 'All Purpose Scissors Orange 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c712174ec8d0c9472c0660009858d66b90fe97d78a5a1f85f8b7361200541e4a.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
